/**
 * errorsReported.tsx - Error Handling Wrapper
 *
 * Provides error handling wrapper for async functions.
 */

import { errorMessage } from "core"

export interface ErrorsReportedOptions {
    setError?
    message?: string
    onFinished?: () => void
}

const fullMessage = (error, message) => message ? `${message}: ${errorMessage(error)}` : errorMessage(error)

const noop = () => null
export const EXIT_MARKER = "__EXIT_MARKER__"

export const errorsReported = <F extends (...args: any[]) => any>(f: F, { message = "", onFinished = noop, setError }: ErrorsReportedOptions): F => {
    const wrapper = (...args: any[]) => {
        try {
            const rt = f.apply(this, args)

            if (!rt || !(rt.then && rt.catch)) {
                onFinished()
                return rt
            }
            return rt.then(v => {
                if (v === EXIT_MARKER) {
                    return
                }
                onFinished()
                return v
            }, error => {
                setError(fullMessage(error, message))
                onFinished()
                throw error
            })
        } catch (error) {
            onFinished()
            setError(fullMessage(error, message))
            throw error
        }
    }
    return wrapper as any
}

interface GlobalErrorContext {

}
